module.exports = __webpack_public_path__ + "img/29-girl.5df8c585.svg";